import { addMilliseconds, isAfter, isBefore, isEqual, parseISO, startOfDay } from "date-fns";
import addDuration from "date-fns-duration";
import { utcToZonedTime } from "date-fns-tz";

const pushSlots = <AvailabilitySlot extends { start: Date; end: Date }>(
  stack: AvailabilitySlot[],
  res: AvailabilitySlot[],
  duration: string,
): AvailabilitySlot[] => {
  if (!stack.length) {
    return res;
  }

  res.push(
    ...stack.filter(slot =>
      isBefore(
        addDuration(slot.start as Date, duration),
        addMilliseconds(stack[stack.length - 1].end, 1),
      ),
    ),
  );

  return res;
};

export const filterOutSlotsByDuration = <AvailabilitySlot extends { start: Date; end: Date }>(
  slots: AvailabilitySlot[],
  duration: string,
): AvailabilitySlot[] => {
  const res: AvailabilitySlot[] = [];
  const stack = [];

  for (const slot of slots) {
    if (!stack.length) {
      stack.push(slot);
      continue;
    }

    const topItem = stack[stack.length - 1];

    if (isEqual(topItem.end, slot.start)) {
      stack.push(slot);
    } else {
      pushSlots(stack, res, duration);

      stack.length = 0;
      stack.push(slot);
    }
  }

  pushSlots(stack, res, duration);

  return res;
};

export const filterOutSlotsByLastBookingTime = <
  AvailabilitySlot extends { start: Date; end: Date },
>(
  slots: AvailabilitySlot[],
  lastBookingTime: string,
  timezone: string,
): AvailabilitySlot[] =>
  slots.filter(({ start }) => {
    const startDate = utcToZonedTime(parseISO(start.toISOString()), timezone);

    return !isAfter(startDate, addDuration(startOfDay(startDate), lastBookingTime));
  });
